import React from 'react';
import PropTypes from 'prop-types';
import { CurrencyFormat } from '@lt/components';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import { NBSP } from '../../../../constants/common';
import LinkPopup from '../../../../components/Popup/LinkPopup';

const VisaServiceLabel = ({ label, price, className, visaRulesLink }) => {
  const { t } = useTranslation();
  return (
    <StyledLabel>
      <>
        {label}
        {visaRulesLink ? (
          <>
            {`. ${t('checkout.touristForm.visaService.label')}${NBSP}`}
            <StyledLink href={visaRulesLink}>
              {t('checkout.touristForm.visaService.rules')}
            </StyledLink>
          </>
        ) : null}
      </>
      {price ? (
        <CurrencyFormat
          className={`${className}--price`}
          value={price}
          prefix="+ "
        />
      ) : null}
    </StyledLabel>
  );
};

const StyledLink = styled(LinkPopup)`
  text-decoration: none;
  color: #007aff;
  dis
`;

const StyledLabel = styled.div`
  display: block;
  margin-left: 4px;
`;

VisaServiceLabel.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  price: PropTypes.number,
};
VisaServiceLabel.defaultProps = {
  price: null,
  className: 'visa-service-label',
};

export default VisaServiceLabel;
